import { Component, Vue, Watch } from 'vue-property-decorator'
import { getProductList } from '@/api/product/product'
import { getProductAccountList } from '@/api/product/productAccount'

@Component({
  name: 'ProductOptionMixin'
})
export default class extends Vue {
  protected queryForm: any = {
    product_code: null,
    product_account_no: null,
    product_type: null
  }
  protected productList: any[] = []
  protected inProductList: any[] = []
  protected outProductList: any[] = []
  protected productAccountList: any[] = []
  protected onProductList: any[] = []

  @Watch('queryForm.product_code')
  onProductChange () {
    this.queryForm.product_account_no = null
    this.getProductAccountList()
  }

  @Watch('queryForm.currency')
  onCurrencyChange () {
    this.queryForm.product_code = null
    this.getProductList()
  }

  // 获取产品列表
  private async getProductList () {
    try {
      const data: any = {
        status: 1,
        name: 'IMPS'
      }
      await getProductList(data).then((res: any) => {
        this.productList = res
        this.inProductList = this.productList?.filter((item: any) => {
          return (
            item.in_or_out === 1
          )
        })
        this.outProductList = this.productList?.filter((item: any) => {
          return (
            item.in_or_out === 0 &&
            this.queryForm.currency === item.currency &&
            this.queryForm.product_type === item.product_type
          )
        })
        this.onProductList = this.productList.filter((item: any) => {
          return this.queryForm.currency === item.currency
        })
      })
    } catch (e) {}
  }

  // 获取产品账户列表
  private async getProductAccountList (acountName?: string) {
    try {
      const data: any = {
        product_code: this.queryForm.product_code,
        account_name: acountName || '',
        page_size: 100
      }
      await getProductAccountList(data).then((res: any) => {
        this.productAccountList = res.results
      })
    } catch (e) {}
  }

  created () {
    this.getProductList()
  }
}
